module.exports = new __parcel__URL__("pin_oumanger.4538f4e1.png").toString();